import { defineMobileFormWindow } from "@app/overlay";
import {
    StockFinishedGoodsShipmentFilterForm,
    type StockFinishedGoodsShipmentFilterFormProps,
} from "./components/StockFinishedGoodsShipmentFilter/StockFinishedGoodsShipmentFilterForm";

/** Окна списка НС для отгрузки СГП. */
export const stockFinishedGoodsShipmentListWindows = {
    filter: defineMobileFormWindow<StockFinishedGoodsShipmentFilterFormProps>({
        key: "stock.finishedGoodsShipment.filter",
        title: "Фильтр НС",
        component: StockFinishedGoodsShipmentFilterForm,
    }),
} as const;
